import { SET_MENU_DATA, UPDATE_MENU_ITEM_STATUS, DELETE_MENU_CATEGORY } from './constants';

const initialState = {
  data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case UPDATE_MENU_ITEM_STATUS:
      return {
        ...state,
        data: state.data.map(category => ({
          ...category,
          items: category.items.map(item =>
            item.id === action.payload.id
              ? { ...item, isSoldOut: action.payload.isSoldOut }
              : item
          ),
        })),
      };
    case DELETE_MENU_CATEGORY:
      return {
        ...state,
        data: state.data.filter(category => category.id !== action.payload),
      };
    default:
      return state;
  }
};

export default reducer;